import { LoginModalContext } from "@/components/LoginModal/LoginModalProvider";
import { useContext } from "react";

export function useLoginModal() {
  const context = useContext(LoginModalContext);
  if (context === undefined) {
    throw new Error(
      "useLoginModalContext must be used within a LoginModalProvider"
    );
  }
  return context;
}
